const uz = {
  lang: 'uz',
  langLabel: "O'Z",
  langName: "O'zbek",

  common: {
    save: 'Saqlash',
    cancel: 'Bekor qilish',
    delete: "O'chirish",
    edit: 'Tahrirlash',
    add: "Qo'shish",
    back: 'Orqaga',
    search: 'Qidirish',
    loading: 'Yuklanmoqda…',
    submitting: 'Yuborilmoqda…',
    saving: 'Saqlanmoqda…',
    confirm: 'Tasdiqlash',
    close: 'Yopish',
    yes: 'Ha',
    no: "Yo'q",
    actions: 'Amallar',
    status: 'Holat',
    name: 'Ism',
    email: 'Email',
    phone: 'Telefon',
    address: 'Manzil',
    date: 'Sana',
    notes: 'Izohlar',
    description: 'Tavsif',
    total: 'Jami',
    active: 'Faol',
    inactive: 'Faol emas',
    all: 'Barchasi',
    export: 'Eksport',
    import: 'Import',
    create: 'Yaratish',
    update: 'Yangilash',
    refresh: 'Yangilash',
    logout: 'Chiqish',
    noData: "Ma'lumot topilmadi",
    error: 'Xatolik yuz berdi',
    success: 'Muvaffaqiyatli',
    required: 'majburiy',
    optional: 'ixtiyoriy',
    notAssigned: "Belgilanmagan",
    noneSelected: '-- Tanlang --',
    history: 'Tarix',
    view: "Ko'rish",
    details: 'Tafsilotlar',
    areYouSure: 'Ishonchingiz komilmi?',
    cannotUndo: "Bu amalni bekor qilib bo'lmaydi.",
    currency: 'UZS',
    month: 'Oy',
    year: 'Yil',
  },

  status: {
    ACTIVE: 'Faol',
    INACTIVE: 'Faol emas',
    PENDING: 'Kutilmoqda',
    PAID: "To'landi",
    OVERDUE: 'Muddati o\'tgan',
    CANCELLED: 'Bekor qilindi',
    COMPLETED: 'Yakunlandi',
    SCHEDULED: "Rejalashtirilgan",
    APPROVED: 'Tasdiqlandi',
    REJECTED: 'Rad etildi',
    ON_LEAVE: "Ta'tilda",
    SUSPENDED: 'To\'xtatildi',
    TERMINATED: 'Ishdan bo\'shatildi',
    RESIGNED: 'Iste\'fo berdi',
    PRESENT: 'Keldi',
    ABSENT: 'Kelmadi',
    LATE: 'Kech keldi',
    EXCUSED: "Uzrli sabab",
  },

  nav: {
    dashboard: 'Boshqaruv paneli',
    students: 'Talabalar',
    teachers: "O'qituvchilar",
    groups: 'Guruhlar',
    payments: "To'lovlar",
    expenditures: 'Xarajatlar',
    exams: 'Imtihon va baholar',
    certificates: 'Sertifikatlar',
    attendance: 'Davomat',
    homework: 'Uy vazifalari',
    comments: 'Izohlar',
    telegram: 'Telegram',
    staff: 'Xodimlar',
    messages: 'Xabarlar',
    reports: 'Hisobotlar',
    centers: 'Markazlar',
    teacherSalaries: "O'qituvchilar maoshi",
    printMaterials: 'Chop materiallari',
    logout: 'Chiqish',
    atRisk: "Xavf ostidagi o'quvchilar",
    marketIntel: 'Bozor razvedkasi',
    competitors: 'Raqobatchilar',
    marketReport: 'Bozor hisoboti',
  },

  auth: {
    selectSchool: 'Maktabingizni tanlang',
    selectSchoolSub: 'Davom etish uchun til markazingizni tanlang',
    noSchool: 'Maktabingizni ko\'rmayapsizmi?',
    registerSchool: 'Maktabni ro\'yxatdan o\'tkaring →',
    platformAdmin: 'Platforma admini kirishi',
    loginTitle: 'Xush kelibsiz',
    loginSub: 'Hisobingizga kiring',
    email: 'Email',
    password: 'Parol',
    signIn: 'Kirish',
    forgotPassword: 'Parolni unutdingizmi?',
    noAccount: 'Hisobingiz yo\'qmi?',
    signUp: "Ro'yxatdan o'tish",
    backToLogin: '← Kirishga qaytish',
    changeCenter: "O'zgartirish",
    registerTitle: "Maktabni ro'yxatdan o'tkaring",
    registerSub: "School CRM hisobingizni bir necha daqiqada sozlang",
    newSchool: 'Yangi maktab',
    joinExisting: 'Mavjudga qo\'shilish',
    firstName: 'Ism',
    lastName: 'Familiya',
    centerName: 'Maktab nomi',
    centerCode: 'Maktab kodi',
    centerAddress: 'Manzil',
    brandColor: 'Brend rangi',
    confirmPassword: 'Parolni tasdiqlang',
    passwordMismatch: 'Parollar mos kelmaydi',
    passwordTooShort: "Parol kamida 6 ta belgidan iborat bo'lishi kerak",
    createAccount: 'Hisob yaratish',
    verifyTitle: 'Elektron pochtangizni tekshiring',
    verifyCode: 'Quyidagi manzilga yuborilgan 6 xonali kodni kiriting',
    resend: 'Qayta yuborish',
    verify: 'Tasdiqlash',
    forgotTitle: 'Parolni unutdingizmi?',
    forgotSub: "Xavotir olmang, sizga 6 xonali tiklash kodi yuboramiz.",
    sendCode: 'Kod yuborish',
    resetTitle: 'Tiklash kodini kiriting',
    resetSub: 'Tiklash kodi yuborildi',
    newPasswordTitle: 'Yangi parol o\'rnating',
    newPasswordSub: 'Hisobingiz uchun kuchli parol tanlang.',
    newPassword: 'Yangi parol',
    setPassword: 'Parolni o\'rnatish',
    doneTitle: 'Parol tiklandi!',
    doneSub: "Parolingiz muvaffaqiyatli yangilandi. Endi yangi parol bilan kirishingiz mumkin.",
    signInNow: 'Kirish',
    platformTitle: 'Platforma admini',
    platformSub: "Cheklangan kirish — faqat vakolatli shaxslar uchun",
    signInPlatform: 'Platforma admini sifatida kirish',
    wrongRole: "Bu kirish faqat platforma adminlari uchun",
    strengthWeak: 'Zaif',
    strengthFair: "O'rta",
    strengthStrong: 'Kuchli',
    resendIn: 'Qayta yuborish',
    seconds: 's',
    codeExpired: 'Kod eskirganmi?',
    backToSignup: '← Ro\'yxatdan o\'tishga qaytish',
  },

  dashboard: {
    title: '📊 Boshqaruv paneli',
    activeStudents: 'Faol talabalar',
    teachers: "O'qituvchilar",
    groups: 'Guruhlar',
    studentsPaid: "To'lagan talabalar",
    studentsPending: "To'lov kutilmoqda",
    studentsOverdue: "Muddati o'tgan",
    present: 'Keldilar',
    absent: 'Kelmadi',
    late: 'Kech keldi',
    paymentStatus: '💰 To\'lov holati',
    attendanceMonth: '📝 Bugungi davomat',
    alerts: '🚨 Ogohlantirishlar',
    quickActions: 'Tezkor amallar',
    systemStatus: 'Tizim holati',
    paidThisMonth: 'bu oy to\'ladi',
    awaitingPayment: 'to\'lov kutilmoqda',
    overdueMonth: 'bu oy muddati o\'tgan',
    totalInDB: 'ma\'lumotlar bazasida jami',
    activeInstructors: 'Faol o\'qituvchilar',
    allActiveGroups: 'Barcha faol guruhlar',
    records: 'yozuvlar',
    addStudent: '➕ Talaba qo\'shish',
    addTeacher: '➕ O\'qituvchi qo\'shish',
    createGroup: '➕ Guruh yaratish',
    dismissAll: 'Barchasini yopish',
    loadingAlerts: 'Ogohlantirishlar yuklanmoqda…',
    activeOf: 'faol, jami',
    activeGroups: 'faol guruhlar',
    paid: "to'landi",
    unpaid: "to'lanmadi",
  },

  students: {
    title: '👥 Talabalar',
    addStudent: '➕ Talaba qo\'shish',
    deleteAll: '🗑️ Barchasini o\'chirish',
    exportCsv: '📥 CSV eksport',
    importStudents: '📤 Talabalarni import qilish',
    searchPlaceholder: 'Ism yoki talaba ID bo\'yicha qidirish…',
    totalStudents: 'Jami talabalar',
    showing: 'Ko\'rsatilmoqda',
    results: 'natija',
    noStudents: 'Qidiruv bo\'yicha talabalar topilmadi',
    noStudentsYet: "Talabalar yo'q. Boshlash uchun talabalarni import qiling.",
    failedLoad: '❌ Talabalarni yuklab bo\'lmadi',
    deleted: '✅ Talaba muvaffaqiyatli o\'chirildi',
    failedDelete: '❌ Talabani o\'chirib bo\'lmadi',
    errorDelete: '❌ Talabani o\'chirishda xatolik',
    confirmDelete: 'Bu talabani o\'chirishni istaysizmi?',
    confirmDeleteAll: '⚠️ OGOHLANTIRISH: Bu BARCHA talabalar va ota-onalarni o\'chiradi. Rostdan ham ishonchingiz komilmi?',
    typeToConfirm: '"DELETE ALL" yozing tasdiqlash uchun.',
    studentId: 'Talaba ID',
    groups: 'Guruhlar',
    groupCount: 'guruh',
  },

  teachers: {
    title: '👨‍🏫 O\'qituvchilarni boshqarish',
    subtitle: "Barcha o'qituvchilar va ularning topshiriqlarini boshqarish",
    addTeacher: '➕ O\'qituvchi qo\'shish',
    searchPlaceholder: '🔍 O\'qituvchilarni qidirish…',
    noTeachers: 'O\'qituvchilar topilmadi',
    tryAdjusting: 'Qidiruv parametrlarini o\'zgartirib ko\'ring',
    confirmDelete: 'Bu o\'qituvchini o\'chirishni istaysizmi?',
    specialization: '🎯 Mutaxassislik',
    editTeacher: '✏️ O\'qituvchini tahrirlash',
    firstName: 'Ism',
    lastName: 'Familiya',
    password: 'Parol',
    updateTeacher: 'O\'qituvchini yangilash',
  },

  groups: {
    title: '📚 Guruhlar',
    addGroup: '➕ Guruh qo\'shish',
    editGroup: 'Guruhni tahrirlash',
    addNewGroup: 'Yangi guruh qo\'shish',
    searchPlaceholder: 'Guruh nomi yoki kodi bo\'yicha qidirish…',
    totalGroups: 'Jami guruhlar',
    groupName: 'Guruh nomi',
    groupCode: 'Guruh kodi',
    level: 'Daraja',
    maxStudents: 'Maks. talabalar',
    teacher: 'O\'qituvchi',
    schedule: 'Jadval',
    noTeacher: '-- O\'qituvchisiz --',
    createGroup: 'Guruh yaratish',
    updateGroup: 'Guruhni yangilash',
    manageStudents: '👥 Talabalarni boshqarish',
    enrolled: 'Ro\'yxatda',
    available: 'Mavjud',
    searchEnrolled: 'Ro\'yxatdagilar orasida qidirish…',
    searchAvailable: 'Mavjudlar orasida qidirish…',
    remove: 'Olib tashlash',
    noStudentsEnrolled: "Hali talabalar yo'q",
    allEnrolled: 'Barcha talabalar ro\'yxatda',
    noHistory: 'Tarix topilmadi.',
    historyNote: 'Guruhga ro\'yxatga olishning to\'liq tarixi — qo\'shilgan yoki olib tashlangan barcha talabalar.',
    added: 'Qo\'shilgan',
    removed: 'Olib tashlangan',
    students: 'Talabalar',
    sessions: 'Darslar',
    noGroups: 'Guruhlar topilmadi',
    confirmDeleteGroup: 'Bu guruhni o\'chirishni istaysizmi?',
    confirmRemoveStudent: 'Bu talabani guruhdan olib tashlaysizmi?',
    levels: {
      A1: 'A1 - Boshlang\'ich',
      A2: 'A2 - Elementar',
      B1: 'B1 - O\'rta',
      B2: 'B2 - O\'rta-yuqori',
      C1: 'C1 - Ilg\'or',
      C2: 'C2 - Mukammal',
    },
  },

  attendance: {
    title: '📊 Davomat statistikasi',
    subtitle: 'Barcha guruhlar · davomat statistikasi',
    totalSessions: 'Jami darslar',
    overallRate: 'Umumiy ko\'rsatkich',
    searchPlaceholder: 'Guruh nomi, kodi yoki o\'qituvchi bo\'yicha qidirish…',
    sortBy: 'Saralash:',
    byName: 'Nom bo\'yicha',
    byRate: "Ko'rsatkich bo'yicha",
    bySessions: 'Darslar bo\'yicha',
    byStudents: 'Talabalar bo\'yicha',
    noSessions: 'Darslar yo\'q',
    noGroups: 'Guruhlar topilmadi.',
    viewAbsent: '🔴 Kelmaydiganlarni ko\'rish',
    absentStudents: '🔴 Kelmagan talabalar',
    addComment: 'Bu talaba uchun izoh qo\'shing…',
    noAbsent: 'Bu darsda kelmagan talabalar yo\'q.',
    loadingSessions: 'Darslar yuklanmoqda…',
    noSessionsRecorded: 'Hali darslar qayd etilmagan.',
    rate: "Ko'rsatkich",
    lastSession: 'Oxirgi dars',
    attendanceRate: 'Davomat',
    markAttendance: 'Davomatni belgilash',
    present: 'Keldi',
    absent: 'Kelmadi',
    late: 'Kech keldi',
    excused: 'Uzrli',
    submit: 'Davomatni saqlash',
  },

  payments: {
    title: '💰 To\'lovlarni boshqarish',
    addPayment: 'To\'lov qo\'shish',
    amount: 'Summa',
    method: 'To\'lov usuli',
    dueDate: 'To\'lov muddati',
    paidAt: 'To\'langan sana',
    invoiceNumber: 'Hisob-faktura №',
    methods: {
      CASH: 'Naqd',
      CARD: 'Karta',
      TRANSFER: 'O\'tkazma',
      ONLINE: 'Onlayn',
    },
    statuses: {
      PAID: "To'landi",
      PENDING: 'Kutilmoqda',
      OVERDUE: 'Muddati o\'tgan',
      CANCELLED: 'Bekor qilindi',
    },
    markPaid: "To'langan deb belgilash",
    passcodeRequired: 'Kirish kodi kerak',
    incorrectPasscode: 'Noto\'g\'ri kirish kodi',
    monthlyRevenue: 'Oylik daromad',
    collected: 'Yig\'ildi',
    expected: 'Kutilmoqda',
  },

  expenditures: {
    title: '📉 Xarajatlar',
    addExpenditure: 'Xarajat qo\'shish',
    category: 'Kategoriya',
    categories: {
      ALL: 'Barchasi',
      RENT: 'Ijara',
      UTILITIES: 'Kommunal',
      SALARIES: 'Maoshlar',
      SUPPLIES: 'Ehtiyot qismlar',
      EQUIPMENT: 'Jihozlar',
      MARKETING: 'Marketing',
      MAINTENANCE: 'Texnik xizmat',
      CLEANERS: 'Tozalash',
      OTHER: 'Boshqa',
    },
    confirmDelete: 'Bu xarajatni o\'chirasizmi?',
    title_field: 'Sarlavha',
    totalSpent: 'Jami sarflandi',
    dailyTotal: 'Kunlik jami',
  },

  exams: {
    title: '📋 Imtihon va baholar',
    addExam: 'Imtihon qo\'shish',
    examTitle: 'Imtihon nomi',
    subject: 'Fan',
    type: 'Tur',
    group: 'Guruh',
    maxScore: 'Maks. ball',
    passingScore: 'O\'tish bali',
    gradeEntry: 'Baholar kiritish',
    saveGrades: 'Baholarni saqlash',
    gradesSaved: 'Baholar saqlandi!',
    avgScore: "O'rtacha ball",
    passRate: "O'tish foizi",
    confirmDelete: 'Bu imtihon va uning barcha natijalarini o\'chirasizmi?',
    types: {
      WRITTEN: 'Yozma',
      ORAL: "Og'zaki",
      PRACTICAL: 'Amaliy',
      ONLINE: 'Onlayn',
      QUIZ: 'Test',
    },
    statuses: {
      SCHEDULED: 'Rejalashtirilgan',
      COMPLETED: 'Yakunlandi',
      CANCELLED: 'Bekor qilindi',
    },
    score: 'Ball',
    absent: 'Qatnashmadi',
    participant: 'Ishtirokchilar',
  },

  comments: {
    title: '💬 Talabalar haqida fikrlar',
    addFeedback: 'Fikr qo\'shish',
    selectGroup: 'Guruhni tanlang',
    selectStudent: 'Talabani tanlang',
    quickComments: 'Tezkor izohlar',
    commentPlaceholder: 'Talaba haqida fikringizni yozing…',
    addComment: '💬 Izoh qo\'shish',
    recentFeedback: "So'nggi fikrlar",
    noComments: "Hozircha izohlar yo'q",
    by: 'Muallif',
    failedLoad: '❌ Yuklab bo\'lmadi',
    added: '✅ Izoh muvaffaqiyatli qo\'shildi!',
    failedAdd: '❌ Izoh qo\'shib bo\'lmadi',
  },

  homework: {
    title: '📓 Uy vazifalari',
    addHomework: 'Vazifa qo\'shish',
    dueDate: 'Topshirish muddati',
    points: 'Ballar',
    type: 'Tur',
    submissions: 'Javoblar',
    results: 'Natijalar',
    confirmDelete: 'Bu uy vazifasini o\'chirishni istaysizmi?',
    noHomework: 'Uy vazifalari topilmadi',
    titleRequired: '❌ Sarlavha va muddat kerak',
    created: '✅ Uy vazifasi muvaffaqiyatli yaratildi!',
    deleted: '✅ Uy vazifasi o\'chirildi',
  },

  staff: {
    title: '👔 Xodimlarni boshqarish',
    addStaff: 'Xodim qo\'shish',
    employeeId: 'Xodim ID',
    position: 'Lavozim',
    department: 'Bo\'lim',
    employmentType: 'Ish turi',
    hireDate: 'Ishga qabul sanasi',
    baseSalary: 'Asosiy maosh',
    paymentFrequency: "To'lov davriyligi",
    emergencyContact: 'Favqulodda aloqa',
    types: {
      FULL_TIME: 'To\'liq stavka',
      PART_TIME: 'Yarim stavka',
      CONTRACT: 'Shartnoma',
    },
  },

  messages: {
    title: '📨 Xabarlar',
    typeMessage: 'Xabar yozing…',
    send: 'Yuborish',
    teachers: "O'qituvchilar",
    students: 'Talabalar',
    parents: 'Ota-onalar',
    admin: 'Administrator',
    noConversation: 'Muloqotni boshlash uchun suhbatni tanlang',
  },

  teacherPortal: {
    title: '🎓 O\'qituvchi portali',
    home: '🏠 Bosh sahifa',
    myGroups: '📚 Mening guruhlarim',
    attendance: '📝 Davomat',
    homework: '📓 Uy vazifalari',
    exams: '📋 Imtihon va baholar',
    comments: '💬 Izohlar',
    logout: '🚪 Chiqish',
    welcome: 'Xush kelibsiz',
    todayOverview: "Bugungi umumiy ko'rinish.",
    myGroupsLabel: 'Mening guruhlarim',
    totalStudents: 'Jami talabalar',
    today: 'Bugun',
    noGroups: "Hali guruhlar belgilanmagan.",
    attendanceBtn: 'Davomat',
    gradesBtn: 'Baholar',
    submitAttendance: 'Davomatni saqlash',
    saving: 'Saqlanmoqda…',
    commentAdded: '✅ Izoh muvaffaqiyatli qo\'shildi',
    addComment: 'Izoh qo\'shish',
    selectStudent: 'Talabani tanlang',
    commentText: 'Izoh',
    commentPlaceholder: 'Izohingizni yozing…',
  },

  parentPortal: {
    title: '👨‍👩‍👧 Ota-ona portali',
    myChild: 'Mening farzandim',
    attendance: 'Davomat',
    payments: "To'lovlar",
    comments: 'Izohlar',
    groups: 'Mening guruhlarim',
    attendanceCalendar: 'Davomat taqvimi',
    present: 'Keldi',
    absent: 'Kelmadi',
    late: 'Kech keldi',
    excused: 'Uzrli',
    noData: 'Bu davr uchun ma\'lumot yo\'q',
    recentPayments: "So'nggi to'lovlar",
    recentComments: "So'nggi izohlar",
    noPayments: "To'lov yozuvlari yo'q",
    noComments: "Hozircha izohlar yo'q",
    level: 'Daraja',
    teacher: "O'qituvchi",
    schedule: 'Jadval',
    days: ['Yak', 'Du', 'Se', 'Ch', 'Pa', 'Ju', 'Sh'],
    months: ['Yanvar', 'Fevral', 'Mart', 'Aprel', 'May', 'Iyun', 'Iyul', 'Avgust', 'Sentabr', 'Oktabr', 'Noyabr', 'Dekabr'],
  },

  master: {
    title: 'Bosh boshqaruv paneli',
    subtitle: 'Platformadagi barcha maktablarni kuzatish va boshqarish',
    totalSchools: 'Jami maktablar',
    totalStudents: 'Jami talabalar',
    totalTeachers: "Jami o'qituvchilar",
    monthlyRevenue: 'Bu oylik daromad',
    searchPlaceholder: 'Maktablarni nom yoki kod bo\'yicha qidirish…',
    viewDetails: 'Batafsil',
    disable: "O'chirish",
    enable: 'Yoqish',
    resetPw: 'Parolni tiklash',
    resetPassword: 'Parolni tiklash',
    newPassword: 'Yangi parol (kamida 6 ta belgi)',
    lastActivity: 'Oxirgi faollik',
    avgExamScore: "O'rtacha imtihon bali",
    never: 'Hech qachon',
    backToSchools: '← Barcha maktablarga qaytish',
    monthlyRevenueLabel: 'Oylik daromad',
    newStudents: 'Yangi talabalar',
    recentExams: "So'nggi imtihonlar",
    paidThisMonth: "To'landi (bu oy)",
    pending: 'Kutilmoqda',
    overdue: 'Muddati o\'tgan',
    signOut: 'Chiqish',
    platformLabel: 'MASTER',
    revenue: 'Daromad',
    thisMonth: 'bu oy',
    loadingPlatform: 'Platforma ma\'lumotlari yuklanmoqda…',
    failedLoad: 'Ma\'lumotlarni yuklab bo\'lmadi',
    examCol: 'Imtihon',
    groupCol: 'Guruh',
    dateCol: 'Sana',
    avgScoreCol: "O'rtacha ball",
    passRateCol: "O'tish foizi",
    studentsCol: 'Talabalar',
  },

  centers: {
    title: '🏢 Til markazlari',
    subtitle: 'Tashkilotingiz markazlarini boshqaring. Har bir markaz o\'z kirishiga ega.',
    addCenter: '+ Markaz qo\'shish',
    newCenter: 'Yangi markaz',
    editCenter: 'Markazni tahrirlash',
    centerName: 'Markaz nomi',
    code: 'Kod',
    codeHint: '(noyob slug, boʻshliqsiz)',
    logoUrl: 'Logo URL',
    logoOptional: '(ixtiyoriy)',
    brandColor: 'Brend rangi',
    preview: 'Ko\'rinish',
    created: '✅ Markaz yaratildi',
    updated: '✅ Markaz yangilandi',
  },
  certificates: {
    title: 'Sertifikatlar',
    addCertificate: 'Sertifikat qo\'shish',
    editCertificate: 'Sertifikatni tahrirlash',
    student: 'Talaba',
    teacher: 'O\'qituvchi',
    type: 'Turi',
    examDate: 'Imtihon sanasi',
    issueDate: 'Berilgan sana',
    result: 'Natija',
    notes: 'Izohlar',
    typeIELTS: 'IELTS',
    typeCEFR: 'CEFR',
    typeCUSTOM: 'Boshqa',
    ieltsOverall: 'Umumiy ball',
    ieltsListening: 'Listening',
    ieltsReading: 'Reading',
    ieltsWriting: 'Writing',
    ieltsSpeaking: 'Speaking',
    cefrLevel: 'CEFR darajasi',
    customName: 'Sertifikat nomi',
    customResult: 'Natija / Ball',
    statistics: 'Statistika',
    totalCertificates: 'Jami sertifikatlar',
    byTeacher: 'O\'qituvchi bo\'yicha',
    avgBand: 'O\'rtacha IELTS ball',
    ieltsDistribution: 'IELTS ball taqsimoti',
    cefrDistribution: 'CEFR daraja taqsimoti',
    monthlyTrend: 'Oylik tendensiya',
    exportExcel: 'Excelga eksport',
    annual: 'Yillik',
    monthly: 'Oylik',
    noCertificates: 'Sertifikat topilmadi',
    confirmDelete: 'Ushbu sertifikatni o\'chirishni xohlaysizmi?',
    saved: 'Sertifikat muvaffaqiyatli saqlandi',
    deleted: 'Sertifikat o\'chirildi',
    list: 'Sertifikatlar',
    certificateFile: 'Sertifikat fayli',
    viewFile: 'Ko\'rish',
    uploadFile: 'PDF yoki rasm yuklang (maks 10 MB)',
  },

  market: {
    title: 'Bozor razvedkasi',
    competitors: 'Raqobatchilar',
    marketReport: 'Bozor hisoboti',
    threatLevel: 'Xavf darajasi',
    bcPartner: 'BC Hamkor',
    high: 'Yuqori',
    medium: "O'rta",
    low: 'Past',
    addCompetitor: 'Raqobatchi qo\'shish',
    editCompetitor: 'Tahrirlash',
    deactivate: 'Faolsizlashtirish',
    history: 'Tarix',
    noHistory: 'Tarix yo\'q.',
    consideredBy: 'Ko\'rib chiqdi',
    studentsLost: "Ketgan o'quvchilar",
    lastChecked: 'Oxirgi tekshiruv',
    source: 'Qanday topdi',
    whyChoseUs: 'Nima uchun bizni tanladi',
    homeDistrict: 'Yashash tumani',
    leavingReason: 'Ketish sababi',
    wentToCompetitor: 'Raqobatchiga o\'tdi',
    whichCompetitor: 'Qaysi raqobatchi?',
    sourceTelegram: 'Telegram',
    sourceInstagram: 'Instagram',
    sourceFriendFamily: 'Do\'st yoki oila',
    sourceCurrentStudent: "Hozirgi o'quvchi",
    source2GIS: '2GIS / Yandex Xaritalar',
    sourceFlyerBanner: 'Varaqcha yoki banner',
    sourceSchoolEvent: 'Maktab tadbirida',
    sourceWalkIn: 'Yaqindan o\'tdi',
    sourceOther: 'Boshqa',
    reasonPrice: 'Narx',
    reasonSchedule: 'Jadval',
    reasonDistance: 'Masofa',
    reasonWentToCompetitor: 'Raqobatchiga ketdi',
    reasonTeacher: "O'qituvchi",
    reasonResults: 'Natijalar',
    reasonMovedAway: 'Ko\'chib ketdi',
    reasonNoReply: 'Javob yo\'q',
    reasonOther: 'Boshqa',
  },
};

export default uz;
